<template>
    <div id="page_loader">
        <div class="loader" id="page_loader_spinner"><div></div><div></div><div></div><div></div></div>
    </div>
</template>
<script lang="ts">
import './LoaderComponent.css';
import { defineComponent } from 'vue';

export default defineComponent({
    mounted() {
        
    },
});
</script>
